import { render, staticRenderFns } from "./pageView.vue?vue&type=template&id=044585e8&"
import script from "./pageView.vue?vue&type=script&lang=js&"
export * from "./pageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports